// extracted by mini-css-extract-plugin
export default {"prereq":"styles_prereq__o5NEq","choices":"styles_choices__Mjwc3","footer":"styles_footer__sv5q-"};